import React, { memo, useState } from "react";
import AxiomLoginForm from "./AxiomLoginForm";
import AxiomLoginD3Viz from "./AxiomLoginD3Viz";
import './LoginWithBubble.scss'

function LogInWithBubble(props) {
  const {
    includeHeaderText,
    includeSubHeaderText,
    includeAppLogo,
    headerText,
    subHeaderText,
    loginLogoHeight,
    onChange,
    email,
    password,
    doLogin,
    isMonitorLoginEnabled,
    loginOptions,
    appLogo,
    onShowPasswordChange,
    showPassword,
    rememberMe,
    onRememberMeChange,
    hideForgotPassword,
    forgotPassword,
    forgotPasswordView,
    sendPasswordLink,
  } = props;

  const DISCLAIMER_STORAGE_KEY = "dataGovernanceConsentDate";

  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [isConsentChecked, setIsConsentChecked] = useState(false);

  const getTodayDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const handleLoginRequest = () => {
    const today = getTodayDate();
    const lastAcceptedDate = localStorage.getItem(
      DISCLAIMER_STORAGE_KEY
    );
    if (lastAcceptedDate === today) {
      doLogin();
      return;
    }
    setIsConsentChecked(false);
    setShowDisclaimer(true);
  };
  const handleAcceptDisclaimer = () => {
    if (!isConsentChecked) return;
    localStorage.setItem(
      DISCLAIMER_STORAGE_KEY,
      getTodayDate()
    );
    setShowDisclaimer(false);
    doLogin();
  };
  const handleDeclineDisclaimer = () => {
    setIsConsentChecked(false);
    setShowDisclaimer(false);
  };

  return (
    <div className="axiom-login">
      <div className="axiom-login-form">
        <AxiomLoginForm
          includeHeaderText={includeHeaderText}
          includeSubHeaderText={includeSubHeaderText}
          includeAppLogo={includeAppLogo}
          headerText={headerText}
          subHeaderText={subHeaderText}
          appLogo={appLogo}
          loginLogoHeight={loginLogoHeight}
          onChange={onChange}
          email={email}
          password={password}
          // doLogin={doLogin}
          doLogin={handleLoginRequest}
          isMonitorLoginEnabled={isMonitorLoginEnabled}
          loginOptions={loginOptions}
          onShowPasswordChange={onShowPasswordChange}
          showPassword={showPassword}
          rememberMe={rememberMe}
          onRememberMeChange={onRememberMeChange}
          hideForgotPassword={hideForgotPassword}
          forgotPassword={forgotPassword}
          forgotPasswordView={forgotPasswordView}
          sendPasswordLink={sendPasswordLink}
        />
      </div>
      <div className="axiom-login-information">
        <AxiomLoginD3Viz />
      </div>
      {showDisclaimer && (
        <div className="governance-consent-overlay" role="presentation">
          <div className="governance-consent-modal" role="dialog" aria-modal="true"
            aria-labelledby="governance-consent-title">

            <div className="governance-consent-header">
              <div className="governance-consent-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 3L4.5 6V11.5C4.5 16.1 7.7 20.2 12 21.3C16.3 20.2 19.5 16.1 19.5 11.5V6L12 3Z"
                    stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
                  <path d="M9 12L11 14L15.5 9.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"
                    strokeLinejoin="round" />
                </svg>
              </div>
              <div className="governance-consent-heading">
                <h2 id="governance-consent-title">
                  Data Governance & Confidentiality Consent
                </h2>
                <p>
                  Please review and acknowledge the following requirements
                  before continuing.
                </p>
              </div>
            </div>

            <div className="governance-consent-body">
              <section className="governance-section">
                <div className="governance-section-title">
                  Declaration & Consent
                </div>
                <p className="governance-intro">
                  By logging into and using this application, I acknowledge and
                  agree that:
                </p>
                <ul className="governance-consent-list">
                  <li>
                    The information, reports, customer data, financial records,
                    and other banking information accessible through this
                    application are confidential and proprietary to the Bank.
                  </li>
                  <li>
                    I will access and use data strictly for authorized business
                    purposes and within the scope of my assigned role and
                    responsibilities.
                  </li>
                  <li>
                    I will not copy, download, share, transmit, disclose, or
                    distribute any customer or banking data to unauthorized
                    individuals, systems, external parties, or personal
                    devices.
                  </li>
                  <li>
                    I will comply with all applicable Data Governance,
                    Information Security, Privacy, and Regulatory policies of
                    the Bank.
                  </li>
                  <li>
                    I understand that customer information is sensitive and
                    must be protected from unauthorized access, misuse,
                    modification, or disclosure.
                  </li>
                  <li>
                    I will immediately report any suspected security incident,
                    data breach, unauthorized access, or misuse of information.
                  </li>
                  <li>
                    I acknowledge that all activities performed within this
                    application, including data access, queries, downloads, and
                    report generation, may be logged, monitored, and audited by
                    the Bank.
                  </li>
                  <li>
                    I understand that any misuse of banking data, customer
                    information, or system access may result in disciplinary
                    action, access revocation, legal proceedings, and
                    regulatory consequences.
                  </li>
                  <li>
                    I understand that my queries and activities are monitored
                    and can be tracked.
                  </li>
                </ul>
              </section>
              <section className="governance-user-consent">
                <div className="governance-user-consent-title">
                  User Consent
                </div>
                <label className="governance-checkbox-wrapper">
                  <input type="checkbox" checked={isConsentChecked} onChange={(e) =>
                    setIsConsentChecked(e.target.checked)
                  }
                  />
                  <span className="governance-custom-checkbox">
                    <svg viewBox="0 0 12 10">
                      <path d="M1 5L4.3 8.2L11 1" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                        strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span className="governance-checkbox-text">
                    I have read, understood, and agree to comply with the
                    Bank&apos;s Data Governance, Information Security, and
                    Confidentiality requirements. I undertake not to misuse any
                    banking data, customer information, or confidential
                    business information accessed through this application.
                  </span>
                </label>
                <p className="governance-consent-note">
                  By clicking <strong>Accept & Continue</strong>, I provide my
                  consent to the above terms and conditions.
                </p>
              </section>
            </div>

            <div className="governance-consent-footer">
              <button type="button" className="governance-decline-button" onClick={handleDeclineDisclaimer}>
                Decline
              </button>
              <button type="button" className="governance-accept-button" disabled={!isConsentChecked}
                onClick={handleAcceptDisclaimer}>
                Accept & Continue
                <svg viewBox="0 0 20 20" fill="none">
                  <path d="M4 10H16M11 5L16 10L11 15" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"
                    strokeLinejoin="round" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default memo(LogInWithBubble);
